"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const matchers_1 = require("../parsers/matchers");
const tokeniser_1 = require("../parsers/tokeniser");
const placeholderMatchers = [
    matchers_1.PlaceholderMatcherAlt, // or §expression§
    matchers_1.PlaceholderMatcher, // placeholders are of the form ${expression}
    matchers_1.DollarMatcher,
    matchers_1.StringMatcher,
];
const getTokensForTokenExpression = (expression) => [
    ...(0, tokeniser_1.getTokens)(expression, placeholderMatchers),
];
exports.default = getTokensForTokenExpression;
